import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {ConsentService} from "../service/consent.service";

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.css']
})
export class CompleteComponent implements OnInit {

  state = 'loading'
  textConfig: any = {};
  group = ''
  idEmitter = ''

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private consentService: ConsentService) { }

  getLogoUrl(logoName: string) {
    this.http.post(environment.api_url + 'onboarding', {
      group: this.group,
      user: this.idEmitter,
      file_name: logoName,
      action: 'getLogoUrl'
    }, {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    }).subscribe( (response: any) => {
        const status = (response as any)['status'];
        const logoUrl = (response as any)['logoUrl'];
        this.consentService.getLogoUrlSubject().next(logoUrl);
      },
      error => {
        console.log(error);
      } );
  }

  decodeUrl(data: string) {
    this.http.post(environment.api_url + 'onboarding', {
      data: data,
      action: 'decodeEmail',
    }, {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    }).subscribe((response) => {
      this.state = 'loaded';
      const status = (response as any)['status'];
      if (status === 'KO') {
        this.router.navigate(['/error']);
      }
      this.group = (response as any)['group'];
      this.idEmitter = (response as any)['idEmitter'];
      this.textConfig = JSON.parse((response as any)['textConfig']);
      this.getLogoUrl(this.textConfig.logoUrl);
    }, () => {
      this.router.navigate(['/error']);
    });
  }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        const data = params['data'];
        this.decodeUrl(data);
      });
  }

}
